import { render, staticRenderFns } from "./VFormTextarea.vue?vue&type=template&id=2ed0530f&"
import script from "./VFormTextarea.vue?vue&type=script&lang=js&"
export * from "./VFormTextarea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports